import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export default class SystemNode extends BaseNode {
    constructor() {
        super();
        this.name = 'On Boot';
        this.id = 'node_system';
        this.icon = 'VscDebugStart';
        this.linkedFeature = 'general';

        this.outputs = [
            {
                name: 'Boot Complete',
                portId: 'boot',
                params: [],
            },
        ];

        const haltPort = new NodePort();
        haltPort.initSettings();
        haltPort.setSettingValue('NAME', 'Halt');
        haltPort.setSettingValue('PORTID', 'sys.halt');

        const rebootPort = new NodePort();
        rebootPort.initSettings();
        rebootPort.setSettingValue('PORTID', 'sys.reboot');
        rebootPort.setSettingValue('NAME', 'Reboot');

        const tickPort = new NodePort();
        tickPort.initSettings();
        tickPort.setSettingValue('NAME', 'System tick');
        tickPort.setSettingValue('PORTID', 'on_sys_timer');

        const bootCompletePort = new NodePort();
        bootCompletePort.initSettings();
        bootCompletePort.setSettingValue('NAME', 'Boot Complete');
        bootCompletePort.setSettingValue('PORTID', 'boot');

        const settings: Setting[] = [

        ];

        this.setSettingValue('INPUTS', [haltPort, rebootPort]);
        this.setSettingValue('OUTPUTS', [bootCompletePort, tickPort]);

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        let links = project.getNodeLinks(this, 'on_sys_timer');

        if (links.length > 0) {
            const link = links[0];
            blocks.push({
                location: 'on_sys_timer',
                blockType: BlockType.CODE,
                id: link.getSourceId(),
                template: `'****${link.getSourceId()}****'`,
            });
        }

        links = project.getNodeLinks(this, 'boot');
        if (links.length > 0) {
            const link = links[0];
            blocks.push({
                location: 'boot_complete',
                blockType: BlockType.CODE,
                id: link.getSourceId(),
                template: `${project.getCodeLocationStart()}${link.getSourceId()}${project.getCodeLocationEnd()}`,
            });
        }

        links = project.getNodeLinks(this, 'sys.halt');
        if (links.length > 0) {
            const link = links[0];
            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                template: 'sys.halt()',
            });
        }

        links = project.getNodeLinks(this, 'sys.reboot');
        if (links.length > 0) {
            const link = links[0];
            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                template: 'sys.reboot()',
            });
        }

        return blocks;
    }

    getDetails(): string {
        return `
This block is triggered after the device has successfully completed initial processes (e.g., configuring network interfaces and peripherals) and is prepared to run the application.`;
    }
}
